import React from "react";
import { KeyboardAvoidingView, StyleSheet, View } from "react-native";

import { isEqual, findLastIndex, find } from "lodash";

import GestureRecognizer, {
  swipeDirections,
} from "react-native-swipe-gestures";

import moment from "moment";

import AppConfig from "../../../config/AppConfig";
import Utils, {
  getStorageKey,
  navigate,
  setStorageItem,
  timeslotsEqual,
  nowUserTz,
  isFitness,
  isSleep,
  hasItems,
  getStorageItem,
  getElementModel,
  isWeb,
  isAndroid,
} from "../../../helpers/utils";

import TrackHomeCalendar from "./calendar/TrackHomeCalendar";
import JournalTimePicker from "./JournalTimePicker";
import TimeSlotsWrapper from "./timeslots/TimeSlotsWrapper";

import JournalHelper from "./JournalHelper";
import { AppStateWatcher } from "../common/AppStateWatcher";
import TrackFabButton from "./TrackFabButton";
import appStyles from "../../appStyles";

import TUTORIALS_DATA from "../tutorials/data";
import TrackBadgeCard from "./TrackBadgeCard";
import TutorialsHelper from "../tutorials/TutorialsHelper";
import MenuEditOptionsPanel from "../common/MenuEditOptionsPanel";
import JournalDialog from "../common/JournalDialog";
import RoutinesDialog from "../routines/RoutinesDialog";
import AppMessages from "../../../config/AppMessages";
import MultipleElements from "./multiple/MultipleElements";
import TrackWarningDialog from "./TrackWarningDialog";
import appPages from "../../../appPages";
import TrackIntegrationsMenu from "./TrackIntegrationsMenu";
import IntegrationsHelper from "../integrations/IntegrationsHelper";
import AutoTrackFabButton from "./AutoTrackFabButton";
import IntegrationMenuOptions from "../integrations/common/IntegrationMenuOptions";
import EmptyTrackPage from "../empty-pages/EmptyTrackPage";
import UsersHelper from "../users/UsersHelper";
import SettingsHelper from "../more/SettingsHelper";
import ElementsHelper from "../elements/ElementsHelper";
import SetupConfig from "../home/cards/onboarding/SetupConfig";
import ManaButton from "../common/ManaButton";
import TrackHomeSelectAllSection from "./timeslots/TrackHomeSelectAllSection";

const DATE_FORMAT = "YYYY-MM-DD";
const THRESHOLD_REFRESH_MS = 5 * 60 * 1000;
const REFRESH_THROTTLE_MS = 5 * 1000;

const AGG_TIMESLOT_SIZE = 30;

const SNOOZE_DURATION = 3600;

export default class TrackHomePage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.settingsStorageKey = SettingsHelper.getPreferencesStorageKey(
      this.controller,
    );
    this.dateStorageKey = getStorageKey(this.controller, "CONFIRMATION_DATE");
    this.snoozeStorageKey = getStorageKey(
      this.controller,
      "SNOOZE_TRACK_WARNINGS",
    );

    this.atusStorageKey = getStorageKey(this.controller, "SKIP_ATUS_WARNING");

    this.lastComputedCounter = -1;

    this.state = {
      journalTimeslot: null,
      multipleElementsTimeslot: null,
      currentTimePickerSlot: null,
      selectedDate: null,
      isAutoReview: true,
      expandedSlots: [],
      timeslots: [],
      timeslotsUpdateCounter: 0,
      computedTimeslotsUpdateCounter: 0,
      lastUpdateTime: 0,
      mariMessage: "",
      tutorialStep: 0,
      showTutorials: false,
      integrationsTs: null,
      isAutoTrackMode: false,
      isLoading: false,
      showEmptyPage: false,
      hasEnabledIntegrations: false,
      bulkSelectedIds: {},
      isBulkEdit: false,
      showIcons: true
    };
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          //this.lastComputedCounter = -1;
          this.refreshPage();
        },
      );
    } else {
      this.refreshPage();
    }
  };

  componentWillUnmount = async () => {
    // Clear date so that when loading tracker for the first time it will show the current day
    Utils.setStorageItem(this.dateStorageKey, null);

    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route?.params?.args;
    } else {
      return this.controller.state.screenArgs?.args?.args;
    }
  }

  _confirmIntegrationMappedElement = () => {
    // Coming from map-element-to-integration page
    const { map_element, timeslot } = this.props.route?.params || {};

    if (map_element && timeslot) {
      this.confirmTimeslotToDb({
        timeslot: { ...timeslot, activity: map_element },
      });
      this.toggleIntegrationMenu(null);
    }
  };

  getEmptyPageStatusData = () => {
    // For new users' empty page
    this.userCreatedTime = UsersHelper.getUserCreatedTime(
      this.controller.state?.settings?.datetime_created,
      this.props.route?.params?.hours,
    );
    const isNewUser = UsersHelper.isNewUser(this.userCreatedTime);

    // For mari message
    if (isNewUser) this.emptyPageRef = React.createRef();

    const hasEnabledIntegrations = IntegrationsHelper.hasEnabledIntegrations(
      this.controller,
    );

    // IF we show enable manual model for new user = autotrack should be ON by default
    const hasManualTracking =
      this.controller.state.settings?.testing_preferences
        ?.enable_manual_tracking == true;

    return {
      showEmptyPage: isNewUser,
      hasEnabledIntegrations,
      hasManualTracking,
    };
  };

  refreshPage = () => {
    // 2021.09.30: Initial interval length on refresh to fix impersonate error
    this.minutesInterval = this.controller.state?.settings?.interval_duration;

    // New user empty pages
    const emptyPageData = this.getEmptyPageStatusData();


    const prefs = this.controller.state?.settings || {};
    const showIcons = prefs.show_icons_in_track_page == null || prefs.show_icons_in_track_page;

    this.setState((state) => ({
      ...state,
      ...emptyPageData,
      showIcons,
      showTutorialOverlay:
        // Show tutorials overlay on request or first time the user enter page
        this.props.route?.params?.showOverlay ||
        (emptyPageData.showEmptyPage
          ? false
          : !SettingsHelper.wasTutorialOverlaySeen(this.controller, "track")),
    }));

    // Clear params
    if (this.props.route?.params?.showOverlay) {
      this.props.navigation?.setParams({ showOverlay: null });
    }

    this.controller.registerRefresh(() => {
      this.initTimeslots(false, null, true);
    });

    // Coming from map-element-to-integration page
    this._confirmIntegrationMappedElement();

    if (this.controller.state.timeslots != null) {
      // Use cached date to return to last confirmed timeslot after update
      console.log(
        new Date().toISOString() + " Init timeslots on mount (cached)",
      );
      Utils.getStorageItem(this.dateStorageKey).then((savedDateTime) => {
        // Fix for Caching after impersonation
        if (true || savedDateTime != this.state.selectedDate) {
          this.groupTimeslotsByDate(
            this.controller.state.timeslots,
            savedDateTime,
            true,
          );
        }

        // Coming from routines
        //this.showOverrideMessage();

        const { selectedDate } = this.state;
        const hasData =
          this.state.TIMESLOTS_DATA &&
          this.state.TIMESLOTS_DATA[savedDateTime || selectedDate] != null;
        if (!hasData) this.initTimeslots();
      });
    } else {
      console.log("Init timeslots on mount");
      this.initTimeslots();
    }
  };

  initTimeslots = (
    resyncWithServer = true,
    newDate = null,
    rebuildTimeSlots = false,
    routineApplied = false,
  ) => {
    if (this.state.isAutoTrackMode) {
      return this.initAutoTrackTimeslots(newDate);
    }

    if (resyncWithServer && this.controller.trackConfirmTriggered != null) {
      const now = +new Date();
      if (now - this.controller.trackConfirmTriggered < REFRESH_THROTTLE_MS) {
        console.log("Server resync postponed");
        resyncWithServer = false;
      }
    }

    console.log(
      new Date().toISOString() +
        " Init timeslots" +
        (resyncWithServer ? " with resync" : ""),
    );

    const { selectedDate } = this.state;

    const oldTimeslots = this.controller.state.timeslots
      ? JSON.parse(JSON.stringify(this.controller.state.timeslots))
      : null;

    // Instant init if data is available
    if (
      oldTimeslots != null &&
      this.state.TIMESLOTS_DATA &&
      this.state.TIMESLOTS_DATA[newDate || selectedDate] != null
    ) {
      this.groupTimeslotsByDate(
        oldTimeslots,
        newDate || selectedDate,
        rebuildTimeSlots,
        routineApplied,
      );
    }

    // Resync with server
    if (resyncWithServer) {
      Utils.getStorageItem(this.dateStorageKey).then((savedDateTime) => {
        console.log("Resync for " + savedDateTime);
        this.controller.getApiData(
          "timeslots",
          { timeslotsDate: savedDateTime },
          (data) => {
            if (
              timeslotsEqual(oldTimeslots, data, savedDateTime) &&
              selectedDate &&
              isEqual(savedDateTime, selectedDate)
              //&& !this.state?.isLoading
            ) {
              var now = +new Date();
              if (now - this.state.lastUpdateTime > THRESHOLD_REFRESH_MS) {
                console.log("Timeslots refresh (expired)");
                this.setState((state) => ({
                  ...state,
                  timeslotsUpdateCounter:
                    (state.timeslotsUpdateCounter || 0) + 1,
                  lastUpdateTime: now,
                }));
              } else {
                console.log("Timeslots identical, skip update");
              }
            } else {
              console.log("Updating for " + savedDateTime);

              // Loading effect
              this.updateStateKeys({ isLoading: true });

              this.groupTimeslotsByDate(data, savedDateTime);
              this.updateStateKeys({ isLoading: false });
            }
          },
        );
      });
    }
  };

  initAutoTrackTimeslots = (date) => {
    const { selectedDate } = this.state;

    this.controller.getApiData(
      "timeslots-autotrack",
      { timeslotsDate: date || selectedDate },
      (data) => {
        console.log("Updating autotracked timeslots for " + selectedDate);
        this.groupTimeslotsByDate(data, date);
        this.updateStateKeys({ isLoading: false });
      },
    );
  };

  isSameActivity(t1, t2) {
    return (
      t1.activity?.id == t2.activity?.id &&
      t1.activity2?.id == t2.activity2?.id &&
      t1.activity3?.id == t2.activity3?.id
    );
  }

  updateSelectedDate = (dateString) => {
    const { isBulkEdit } = this.state;

    if (isBulkEdit) {
      this.showBulkDateChangedWarnings(() => {
        this.updateSelectedDateConfirmed(dateString);
      });
    } else {
      this.updateSelectedDateConfirmed(dateString);
    }
  };

  updateSelectedDateConfirmed = (dateString) => {
    const { TIMESLOTS_DATA } = this.state;

    if (!dateString || !TIMESLOTS_DATA) return;

    this.updateStateKeys({ isLoading: true });

    if (dateString.format) {
      dateString = dateString.format(DATE_FORMAT);
    }

    // No data in the model for the selected date => fetch new data from the API
    try {
      Utils.setStorageItem(this.dateStorageKey, dateString);
      console.log("Init timeslots for date " + dateString);
      this.initTimeslots(true, dateString);
    } catch (error) {
      console.log(error);
    }
  };

  // Group all timeslots by date => when new date is selected either return data from hash or call the api
  groupTimeslotsByDate = (
    timeslots = [],
    savedDateTime = null,
    allowRebuild = true,
    routineApplied = false,
  ) => {
    if (
      !allowRebuild &&
      this.lastComputedCounter === this.state.computedTimeslotsUpdateCounter
    ) {
      console.log(
        "Skip grouping " +
          this.lastComputedCounter +
          " " +
          this.state.computedTimeslotsUpdateCounter,
      );
      return;
    } else {
      console.log(
        "Grouping " +
          this.lastComputedCounter +
          " " +
          this.state.computedTimeslotsUpdateCounter,
      );
    }
    this.lastComputedCounter = this.state.computedTimeslotsUpdateCounter;

    const selectedDateTime = savedDateTime
      ? moment(savedDateTime)
      : Utils.nowUserTz(this.controller);
    let selectedDate = selectedDateTime.startOf("day").format(DATE_FORMAT);
    const prevDate = selectedDateTime
      .startOf("day")
      .add(-1, "days")
      .format(DATE_FORMAT);
    const nextDate = selectedDateTime
      .startOf("day")
      .add(1, "days")
      .format(DATE_FORMAT);

    console.log(
      new Date().toISOString() + " ---> compute timeslots: ",
      " rebuild " + allowRebuild,
      selectedDateTime.format("DD.MM hh:mm:ss"),
    );
    let unconfirmed = new Set();

    const TIMESLOTS_DATA = allowRebuild ? {} : this.state.TIMESLOTS_DATA;
    let scrollToDate = allowRebuild
      ? this.buildTimeslots(
          timeslots,
          savedDateTime,
          TIMESLOTS_DATA,
          unconfirmed,
        )
      : null;

    // Initial scroll
    if (scrollToDate) {
      selectedDate = scrollToDate.format(DATE_FORMAT);
    }

    let newTimeslots = (TIMESLOTS_DATA[selectedDate] || {}).timeslots || [];
    if (newTimeslots.length > 0) {
      const first = newTimeslots[0];
      const last = newTimeslots[newTimeslots.length - 1];

      if (
        first &&
        first.confirmed &&
        prevDate.substring(0, 10) != selectedDate.substring(0, 10)
      ) {
        let prevTimeslots = (TIMESLOTS_DATA[prevDate] || {}).timeslots || [];
        let idx = prevTimeslots.length - 1;
        while (
          idx >= 0 &&
          prevTimeslots[idx] &&
          prevTimeslots[idx].confirmed &&
          this.isSameActivity(prevTimeslots[idx], first)
        ) {
          console.log("insert beginning");
          newTimeslots.unshift(prevTimeslots[idx]);
          idx--;
        }
      }

      if (
        last &&
        last.confirmed &&
        nextDate.substring(0, 10) != selectedDate.substring(0, 10)
      ) {
        let nextTimeslots = (TIMESLOTS_DATA[nextDate] || {}).timeslots || [];
        let idx = 0;
        while (
          idx < nextTimeslots.length &&
          nextTimeslots[idx] &&
          nextTimeslots[idx].confirmed &&
          this.isSameActivity(nextTimeslots[idx], last)
        ) {
          console.log("insert end");
          newTimeslots.push(nextTimeslots[idx]);
          idx++;
        }
      }
    }
    //console.log("new");
    //console.log(newTimeslots);

    const mergedTimeslots = [];
    let prevTimeslot = null;
    let pastUnconfirmedTimeslots = 0;
    JournalHelper.biasPredictions(this.controller, newTimeslots);

    let minTimeslotSize = this.controller.isChunkPredictions()
      ? AppConfig.CHUNKS_SIZE
      : AppConfig.MIN_TIMESLOTS_SIZE;

    let futureUnconfirmedTimeslots = 0;
    let futureCounts = [];
    newTimeslots
      .slice()
      .reverse()
      .forEach((t) => {
        if (t.confirmed) futureUnconfirmedTimeslots = 0;
        else futureUnconfirmedTimeslots++;
        futureCounts.unshift(futureUnconfirmedTimeslots);
      });

    const tutorialHour = moment("11:00 AM", "h:mm a");
    let idx = 0;
    newTimeslots.forEach((t, index) => {
      futureUnconfirmedTimeslots = futureCounts[idx];
      idx++;
      if (this.state.showTutorials && moment(t.time) > tutorialHour) {
        minTimeslotSize = 60;
      }
      if (t.confirmed) pastUnconfirmedTimeslots = 0;
      else pastUnconfirmedTimeslots++;

      if (
        !JournalHelper.mergeTimeslot(
          prevTimeslot,
          t,
          false,
          pastUnconfirmedTimeslots >= 4 && futureUnconfirmedTimeslots >= 4
            ? Math.max(AGG_TIMESLOT_SIZE, minTimeslotSize)
            : minTimeslotSize,
          this.state.expandedSlots,
          this.controller.isChunkPredictions(),
          this.minutesInterval,
        )
      ) {
        prevTimeslot = JSON.parse(JSON.stringify(t));
        mergedTimeslots.push(prevTimeslot);
      }
    });
    //console.log("merged");
    //console.log(mergedTimeslots);

    //console.log(new Date().toISOString() + " Compute done")
    this.setState(
      (state) => ({
        ...state,
        //isLoading: false,
        timeslots: mergedTimeslots,
        computedTimeslotsUpdateCounter: state.timeslotsUpdateCounter,
        lastUpdateTime: +new Date(),
        TIMESLOTS_DATA,
        selectedDate,
        allTimeslots: timeslots,
      }),
      () => {
        // Recompute bulkIds after day change
        if (this.state.isBulkEdit) this.toggleBulkEditMode(true);

        // Tutorials
        if (!routineApplied) {
          const { tutorialStep } = this.getArgs() || {};

          // Coming from routines
          this.showOverrideMessage();

          // Tutorials
          if (!this.state.tutorialStep) {
            this.initTutorials();
          } else if (this.state.tutorialStep <= tutorialStep) {
            this.loadTutorial(tutorialStep);
          }
        }
      },
    );
    //console.log(new Date().toISOString() + " TrackHome state done")
  };

  onRenderComplete = () => {
    let model = {};
    if (this.state.isLoading) {
      model.isLoading = false;
    }

    // Clear messages: keep only user required actions
    if (
      !this.state.mariAction &&
      (model.mariAction || (model.mariMessage && model.mariMessage != ""))
    ) {
      model.mariAction = null;
      model.mariMessage = "";
    }

    this.updateStateKeys(model);
  };

  updateStateKeys(model, cb = () => {}) {
    Object.keys(model).forEach((k) => {
      const oldVal =
        this.state[k] !== null && (k !== "mariMessage" || this.state[k] !== "")
          ? this.state[k]
          : null;
      const newVal =
        model[k] !== null && (k !== "mariMessage" || model[k]) !== ""
          ? model[k]
          : null;
      if (oldVal === newVal) {
        model[k] = undefined;
      }
    });
    if (Object.keys(model).length > 0) {
      this.setState(
        (state) => ({ ...state, ...model }),
        () => cb(),
      );
    }
  }

  buildTimeslots(timeslots, savedDateTime, TIMESLOTS_DATA) {
    // On first load show last unconfirmed timeslot
    let scrollToDate = null;
    let position = 0;
    let noon = null;
    let lastStartDateDay = null;
    let startDateShort = null;
    let endDateSpread = null;
    timeslots
      .filter((t) => t && (t.activity || t.predicted_activities))
      .forEach((t) => {
        const startDate = moment(t.time);

        // On first load keep track of the first unconfirmed timeslot
        if (!savedDateTime && !scrollToDate && !t.activity) {
          scrollToDate = startDate.clone();
        }

        if (startDate) {
          const endDate = startDate.clone().add(t.duration, "minutes");
          const startDateDay = startDate.date();
          const dayChange = startDateDay !== lastStartDateDay;

          if (
            endDateSpread == null ||
            dayChange ||
            (endDate.date() !== startDateDay &&
              (endDate.hour() > 0 || endDate.minutes() > 0))
          ) {
            // To check if slot ends in the next day
            endDateSpread = endDate.format(DATE_FORMAT);
          }

          if (noon == null || dayChange) {
            lastStartDateDay = startDateDay;
            startDateShort = startDate.format(DATE_FORMAT);
            noon = startDate.clone().startOf("day").add(12, "hours");
          }

          if (!TIMESLOTS_DATA[startDateShort])
            TIMESLOTS_DATA[startDateShort] = {
              hasUnconfirmed: false,
              timeslots: [],
            };
          if (!TIMESLOTS_DATA[endDateSpread])
            TIMESLOTS_DATA[endDateSpread] = {
              hasUnconfirmed: false,
              timeslots: [],
            };

          const startStr = startDate.format("h:mm A");
          const endStr = endDate.format("h:mm A");

          const model = {
            ...t,
            position: position,
            startDate: startDateShort,
            endDate: endDate.format(DATE_FORMAT + " HH:mm:ss"),
            startTime: startStr,
            oldStartTime: startStr,
            endTime: endStr,
            oldEndTime: endStr,
            //height: Math.round(t.duration / 2),
            isAutoTracked: Utils.isAutoTracked(t),
          };

          if (!t.activity) {
            // For incomplete red dot
            TIMESLOTS_DATA[startDateShort].hasUnconfirmed = true;
          } else {
            TIMESLOTS_DATA[startDateShort].confirmed =
              (TIMESLOTS_DATA[startDateShort].confirmed || 0) + 1;
          }

          TIMESLOTS_DATA[startDateShort].timeslots.push({ ...model });

          // Overlapping days
          if (endDateSpread != startDateShort) {
            TIMESLOTS_DATA[endDateSpread].timeslots.push({ ...model });
          }
          position++;
        }
      });

    return scrollToDate;
  }

  onSwipe = (direction) => {
    const { SWIPE_LEFT, SWIPE_RIGHT } = swipeDirections;

    switch (direction) {
      case SWIPE_LEFT:
        const currentDate = Utils.nowUserTz(this.controller);
        const selected = moment(this.state.selectedDate);
        const days = currentDate.diff(selected, "days");

        if (days > -1) {
          this.updateSelectedDate(
            moment(this.state.selectedDate).add(1, "days").format(DATE_FORMAT),
          );
        }

        break;
      case SWIPE_RIGHT:
        this.updateSelectedDate(
          moment(this.state.selectedDate).add(-1, "days").format(DATE_FORMAT),
        );
        break;
    }
  };

  goToEditElementPage = (element) => {
    const elementData = ElementsHelper.findById(this.controller, element.id);
    if (elementData) {
      navigate(this.controller, "rn:edit_element", "changepage", {
        element: getElementModel(elementData),
      });
    }
  };

  goToEditPage = (timeslot, params) => {
    // Date check to show warnings
    this.checkWarningDays({ timeslot, isEdit: true }, () => {
      this.goToEditPageConfirmed(timeslot, params);
    });
  };

  goToEditPageConfirmed = (timeslot, params = {}) => {
    if (this.state.isAutoTrackMode) return;

    navigate(this.controller, appPages.trackDetail, "changepage", {
      timeslot,
      ...params,
      sourceUrl: "rn:journal",
      returnUrl: "rn:journal",
    });
  };

  confirmTimeslot = (data = {}) => {
    const { showTutorials, tutorialStep } = this.state;

    if (showTutorials) {
      this.loadTutorial(tutorialStep + 1);
    }

    // Date check to show warnings
    this.checkWarningDays(data, () => {
      this.confirmTimeslotToDb(data);

      // Rapid fire predictions confirmation: queue all confirmations and then reload
      if (data.was_predicted && !data.reload) {
        if (this.timer) clearTimeout(this.timer);

        // Queue refresh action
        this.timer = setTimeout(() => {
          this.initTimeslots(true, null, true);
        }, 2000);
      }
    });
  };

  checkWarningDays = (data, callback = () => {}) => {
    // Check 1h snoozed
    getStorageItem(this.snoozeStorageKey).then((snoozedTimestamp) => {
      const now = moment().unix();

      // if snoozed time is less than 1h skip warnings
      if (snoozedTimestamp && now - snoozedTimestamp < SNOOZE_DURATION) {
        return callback();
      }

      const today = Utils.nowUserTz(this.controller);
      const timeslotDay = moment(data.timeslot?.time);
      const daysDiff = timeslotDay.diff(today, "days");

      if (daysDiff > 0 || daysDiff <= -7) {
        this.updateStateKeys({
          trackWarningTs: {
            ...data,
            timelineDays: daysDiff,
            isEdit: data.isEdit,
          },
        });
      } else {
        callback();
      }
    });
  };

  confirmTimeslotToDb = (data = {}) => {
    const { allTimeslots } = this.state;

    // Save current step in settings for checklist display
    const settings = SettingsHelper.getCurrentSetupProgress(this.controller);
    if (!settings[SetupConfig.autotrack.name])
      SettingsHelper.updateSetupProgress(this.controller, {
        [SetupConfig.autotrack.name]: true,
      });

    // Track multiple elements
    const { activity, activity2, activity3 } = data.timeslot || {};
    if (activity2?.id || activity3?.id) {
      let elementIds = [activity.id];
      if (activity2) elementIds.push(activity2.id);
      if (activity3) elementIds.push(activity3.id);

      JournalHelper.confirmMultipleElements(
        this.controller,
        data.timeslot,
        elementIds.join(","),
        () => this.initTimeslots(true, null, true),
      );
      return;
    }

    this.controller.tracking.track("Confirm Track");
    JournalHelper.saveTimeslotToDB(
      this.controller,
      allTimeslots,
      data,
      this.onConfirmComplete,
    );
  };

  onConfirmComplete = () => {
    this.updateStateKeys({ isLoading: false });

    console.log("Init timeslots on confirm");
    this.initTimeslots(false, null, true);
  };

  // ------------------------------------- WARNINGS -------------------------------------
  toggleTrackWarningDialog = (ts) => {
    this.updateStateKeys({ trackWarningTs: ts });
  };

  goToToday = () => {
    this.toggleTrackWarningDialog(null);
    this.updateSelectedDate(
      Utils.nowUserTz(this.controller).format(DATE_FORMAT),
    );
  };

  continueWarningAction = () => {
    const { selectedRoutine, trackWarningTs } = this.state;

    // Snooze for 1h
    setStorageItem(this.snoozeStorageKey, moment().unix());

    if (selectedRoutine) {
      this.toggleTrackWarningDialog(null);
      this._goToEditRoutine(selectedRoutine);
    } else if (trackWarningTs.isEdit) {
      this.toggleTrackWarningDialog(null);
      this.goToEditPageConfirmed(trackWarningTs.timeslot);
    } else {
      this.confirmTimeslotToDb(trackWarningTs);
      this.toggleTrackWarningDialog(null);
    }
  };

  // ------------------------------------- DIALOGS -------------------------------------
  showManaMindFul = () => {
    this.updateStateKeys({
      showManaMindful: true,
      journalTimeslot: null,
    });

    setTimeout(() => {
      this.updateStateKeys({
        showManaMindful: false,
      });
    }, 5000);
  };

  openJournalDialog = (timeslot) => {
    if (this.state.isAutoTrackMode) return;

    this.updateStateKeys({
      journalTimeslot: timeslot,
      selectedMenuTimeslot: null,
      multipleElementsTimeslot: null,
    });
  };

  openMultipleElementsDialog = (timeslot) => {
    if (this.state.isAutoTrackMode) return;

    this.updateStateKeys({
      journalTimeslot: null,
      selectedMenuTimeslot: null,
      multipleElementsTimeslot: timeslot,
    });
  };

  toggleTimePickerDialog = (timeslot) => {
    if (this.state.isAutoTrackMode) return;

    const { currentTimePickerSlot } = this.state;

    // Time to close the time picker dialog
    if (timeslot.hasUpdatedEndTime) {
      // Autoconfirm timeslot for prev confirmed activities
      if (currentTimePickerSlot.activity) {
        this.confirmTimeslot({ timeslot, reload: true });
      }

      // Close timepicker
      this.updateStateKeys({ currentTimePickerSlot: null });
    } else {
      // Open timepicker
      this.updateStateKeys({ currentTimePickerSlot: timeslot });
    }
  };

  closeTimePicker = () => {
    this.updateStateKeys({
      currentTimePickerSlot: null,
      mariMessage: "",
    });
  };

  updateMariMessage = (mariMessage = "", mariAction = {}) => {
    this.updateStateKeys({ mariMessage, mariAction, mariHighlight: null });
  };

  expandTimeslot = (t) => {
    if (t && t.id) {
      const ids = t.id.split(",");
      let hasExpand = false;
      for (let i in ids) {
        if (!this.state.expandedSlots.includes(ids[i]))
          this.state.expandedSlots.push(ids[i]);
        hasExpand = true;
      }
      if (hasExpand) {
        this.controller.tracking.track("SlotExpand");
      }
    }

    Utils.getStorageItem(this.dateStorageKey).then((savedDateTime) => {
      this.groupTimeslotsByDate(this.controller.state.timeslots, savedDateTime);
    });
  };

  // ------------------------------------- Menu -------------------------------------
  getMenuOptions = (timeslot) => {
    let options = [
      {
        text: "Edit Timeslot Details",
        action: () => this.onMenuAction("edit"),
      },
      {
        text: "Change Start and/or End-Time",
        action: () => this.onMenuAction("time"),
      },
      {
        action: () => this.onMenuAction("notes"),
        text: (timeslot?.note ? "Edit" : "Add") + " Journal Entry",
      },
    ];

    if (timeslot.activity != null) {
      options.push({
        text: "Edit Element",
        action: () => this.onMenuAction("edit_element"),
      });
      options.push({
        action: () => this.onMenuAction("multiple"),
        text: "Track with Another Element",
      });
    }

    if (timeslot.undo_activity) {
      options.push({
        text: "Remove Activity from Timeslot",
        isDelete: true,
        action: () => this.onMenuAction("remove"),
      });
    }

    return options;
  };

  toggleEditMenuOptions = (ts) => {
    if (this.state.isAutoTrackMode) return;

    this.updateStateKeys({
      selectedMenuTimeslot: ts,
    });
  };

  onMenuAction = (actionType = "edit") => {
    const { selectedMenuTimeslot } = this.state;
    if (!selectedMenuTimeslot) return;

    this.updateStateKeys({ selectedMenuTimeslot: null });

    switch (actionType) {
      case "edit":
        this.goToEditPage(selectedMenuTimeslot);
        break;
      case "edit_element":
        this.goToEditElementPage(selectedMenuTimeslot.activity);
        break;
      case "time":
        this.toggleTimePickerDialog(selectedMenuTimeslot);
        break;
      case "notes":
        this.openJournalDialog(selectedMenuTimeslot);
        break;
      case "multiple":
        //this.openMultipleElementsDialog(selectedMenuTimeslot);
        this.goToEditPage(selectedMenuTimeslot, { multiple: true });
        break;
      case "remove":
        this.removeActivity(selectedMenuTimeslot);
        break;
      case "undo":
        this.undoActivity(selectedMenuTimeslot);
        break;
      default:
        break;
    }
  };

  removeActivity = (timeslot) => {
    const updatedTimeslot = {
      ...timeslot,
      activity: {
        id: "-",
      },
      user_confirmed: true,
      hidePredictions: true,
      source: "edit",
    };

    this.confirmTimeslot({
      timeslot: updatedTimeslot,
      is_confirmed: true,
      was_predicted: 0,
      was_first_option: 0,
      reload: true,
      sourceOverride: "undo",
    });
  };

  undoActivity = (timeslot) => {
    const updatedTimeslot = {
      ...timeslot,
      activity: {
        ...timeslot.activity,
        id: "-",
      },
      user_confirmed: true,
      hidePredictions: true,
      source: "edit",
    };

    this.confirmTimeslot({
      timeslot: updatedTimeslot,
      is_confirmed: true,
      was_predicted: 0,
      was_first_option: 0,
      reload: true,
      sourceOverride: "undo",
    });
  };

  jumpToUntracked = () => {
    const untrackedTs = find(this.controller.state.timeslots || [], (t) =>
      hasItems(t.predicted_activities),
    );

    if (untrackedTs?.time) {
      this.updateSelectedDate(moment(untrackedTs.time).format(DATE_FORMAT));
    }
  };

  autotrackDay = () => {
    let action = {
      action: "autotrack_day",
      day: this.state.selectedDate,
    };

    this.controller.apiService.cardAction(action).then(() => {
      this.updateMariMessage("");
      this.initTimeslots(true, null, true, true);
    });
  };

  syncCalendar = () => {
    let action = {
      action: "sync_calendar",
      day: this.state.selectedDate,
      period: "day",
    };

    this.controller.apiService.cardAction(action);
  };

  // ------------------------------------- TUTORIALS -------------------------------------
  initTutorials = async () => {
    const showTrackTutorials = (this.controller?.state?.showTutorials || {})[
      TutorialsHelper.STORAGE_KEYS.track
    ];

    if (showTrackTutorials) {
      setStorageItem(
        this.dateStorageKey,
        nowUserTz(this.controller).format("YYYY-MM-DD HH:mm:ss"),
      );

      this.resetTutorialTimeslots();
      this.loadTutorial(1);
    } else {
      // 2022.01 Disable atus warning
      //this.showHasAtusWarning();
    }
  };

  loadTutorial = (step = 1) => {
    const tutorial = step >= 0 ? TUTORIALS_DATA["track"][step - 1] || {} : {};

    this.setState((state) => ({
      ...state,
      showTutorials: true,
      tutorialStep: step,
      showBadgeCard: step == 6,
      mariMessage: tutorial.message,
      mariAction: tutorial.action
        ? {
            text: tutorial.action.text,
            onPress: () => this.loadTutorial(step + 1),
          }
        : {},
    }));
  };

  goBackFromElements = () => {
    this.updateStateKeys({
      journalTimeslot: null,
      selectedMenuTimeslot: null,
      multipleElementsTimeslot: null,
    });
    this.refreshPage();
  };

  goBackOneStep = () => {
    const { tutorialStep, isAutoTrackMode } = this.state;

    if (isAutoTrackMode) return this.toggleAutoTrackMode(false);

    if (tutorialStep > 1) {
      this.loadTutorial(tutorialStep - 1);
    } else {
      this.onExitTutorial();
    }
  };

  onTutorialTimePickerOpen = () => {
    const { showTrackTutorials } = this.controller?.state?.showTutorials || {};
    if (!showTrackTutorials) return;

    this.loadTutorial(3);
  };

  onBadgePress = () => {
    this.updateStateKeys({
      mariMessage: "",
      mariAction: {},
      showBadgeCard: false,
    });
    this.controller.toggleTutorialsMode();
    TutorialsHelper.saveTutorialStatus(
      this.controller,
      { track: true },
      navigate(this.controller, "rn:home_card", {}),
    );
  };

  howToTrack = () => {
    this.controller.toggleTutorialsMode({
      [TutorialsHelper.STORAGE_KEYS.track]: true,
    });
    this.loadTutorial();
  };

  resetTutorialTimeslots = () => {
    const { allTimeslots, timeslots } = this.state;

    const toUndo = timeslots.filter((t) => {
      return (
        t.activity &&
        !!t.undo_activity &&
        (isFitness(t?.activity.name) || isSleep(t?.activity.name))
      );
    });

    toUndo.forEach((t) => {
      JournalHelper.saveTimeslotToDB(this.controller, allTimeslots, {
        is_confirmed: false,
        undoAll: true,
        timeslot: t,
      });
    });

    if (hasItems(toUndo)) this.initTimeslots();
  };

  onExitTutorial = () => {
    this.setState(
      (state) => ({
        ...state,
        tutorialStep: 0,
        showTutorials: false,
        mariAction: {},
        isLoading: true,
      }),
      () => {
        this.resetTutorialTimeslots();
        this.controller.toggleTutorialsMode();
        setTimeout(() => {
          navigate(this.controller, "home_card");
        }, 100);
      },
    );
  };

  // ------------------------------------- ROUTINES -------------------------------------
  toggleRoutinesDialog = (isOpen) => {
    const { isBulkEdit } = this.state;

    if (isBulkEdit) return this.showBulkRoutinesWarning();

    const { isAutoTrackMode, showEmptyPage } = this.state;

    if (showEmptyPage && this.emptyPageRef?.current) {
      this.emptyPageRef.current.showMariMessage(
        AppMessages.EmptyTrackPageMariMessage,
      );
      return;
    }

    if (isAutoTrackMode) return;

    this.updateStateKeys({ showRoutinesDialog: isOpen });
  };

  showOverrideMessage = () => {
    getStorageItem("overrideRoutine").then((routine) => {
      if (!routine) return;

      setStorageItem("overrideRoutine", null);
      this.updateStateKeys({
        mariMessage: AppMessages.RoutineUserTrackedOverrideMessage,
        mariAction: [
          {
            text: "Dismiss",
            onPress: () => this.dismissRoutineDialog(),
            isDismiss: true,
          },
          {
            text: "Replace",
            onPress: () => this.applyRoutineWithOverride(routine),
          },
        ],
      });
    });
  };

  applyRoutine = (selectedRoutine) => {
    if (!selectedRoutine) return;

    this.toggleRoutinesDialog(false);
    this.updateStateKeys({ selectedRoutine });

    this.checkWarningDays(
      {
        timeslot: {
          time: this.state.selectedDate,
        },
      },
      () => this._goToEditRoutine(selectedRoutine),
    );
  };

  _goToEditRoutine = (selectedRoutine) => {
    const { selectedDate } = this.state;

    this.updateStateKeys({
      selectedRoutine: null,
      trackWarningTs: null,
    });

    navigate(this.controller, "rn:edit_routine", "changepage", {
      routine: selectedRoutine,
      applyDate: selectedDate,
    });
  };

  dismissRoutineDialog = () => {
    this.updateMariMessage("");
    this.initTimeslots(true, null, true, true);
  };

  applyRoutineWithOverride = (routine) => {
    if (!routine) return;

    this.updateMariMessage(AppMessages.RoutineApplyInProgress);

    let action = {
      action: "apply_routine",
      routine_id: routine.id,
      apply_to: routine.time_interval, // day or week
      startTime: this.state.selectedDate,
      overwrite_confirmed: true,
    };

    this.controller.apiService.cardAction(action).then(() => {
      this.updateMariMessage("");
      this.initTimeslots(true, null, true, true);
    });
  };

  // ------------------------------------- INTEGRATIONS -------------------------------------
  toggleIntegrationMenu = async (timeslot) => {
    if (timeslot) {
      const integration = await IntegrationsHelper.getTimeslotIntegrations(
        this.controller,
        timeslot,
      );

      this.updateStateKeys({
        integrationsTs: {
          ...timeslot,
          integration,
          hasIntegrationLoaded: true,
        },
      });
    } else {
      this.updateStateKeys({ integrationsTs: timeslot });
    }
  };

  clearTimeslot = (timeslot) => {
    // Clear activity
    this.undoActivity(timeslot);

    // Close menu
    this.toggleIntegrationMenu(null);

    // Go to details page
    delete timeslot.activity;
    // To show Choose Element message
    delete timeslot.confirmed;

    //this.goToEditPageConfirmed(timeslot, {});
  };

  goToDetailsPage = (timeslot, params) => {
    // Close menu
    this.toggleIntegrationMenu(null);
    this.goToEditPageConfirmed(timeslot, params);
  };

  toggleIntegrationOptionsMenu = (selectedIntegration) => {
    this.setState((state) => ({ ...state, selectedIntegration }));
  };

  // ------------------------------------- AUTOTRACK MODE -------------------------------------
  toggleAutoTrackMode = (isAutoTrackMode) => {
    const showEmptyPage = UsersHelper.isNewUser(this.userCreatedTime);

    this.setState(
      (state) => ({ ...state, isAutoTrackMode, showEmptyPage }),
      () => this.initTimeslots(true, null, true, true),
    );
  };

  // ------------------------------------- EMPTY STATE -------------------------------------
  aboutThisScreen = () => {
    this.setState((state) => ({ ...state, showTutorialOverlay: true }));
  };

  closeTutorialOverlay = () => {
    this.setState((state) => ({ ...state, showTutorialOverlay: false }));
    SettingsHelper.updateTutorialStatus(this.controller, { track: true });
  };

  enableManualMode = (data) => {
    SettingsHelper.updateSettings(this.controller, {
      enable_manual_tracking: !data.isAutoTrackMode,
    });

    this.setState(
      (state) => ({
        ...state,
        hasManualTracking: !data.isAutoTrackMode,
        showEmptyPage: data.showEmptyPage,
      }),
      () => this.updateSelectedDateConfirmed(moment().format(DATE_FORMAT)),
    );
  };

  // ------------------------------------- BULK CLEAR -------------------------------------
  turnAutoConfirmAtusOff = () => {
    SettingsHelper.updatePreferences(
      this.controller,
      { autoconfirm_atus: false },
      () => this.hideAtusWarning(),
    );
  };

  onAtusDialogAction = (action) => {
    setStorageItem(this.atusStorageKey, true);

    if (action == "cancel") {
      this.turnAutoConfirmAtusOff();
    } else if (action == "continue") {
      this.hideAtusWarning();
    } else {
      navigate(this.controller, appPages.integrationsV2);
    }
  };

  showHasAtusWarning = async () => {
    const { timeslots, isBulkEdit } = this.state;

    const skipWarning = await getStorageItem(this.atusStorageKey);

    const hasAtusData =
      !isBulkEdit && // dont display in edit bulk mode
      !skipWarning && // only show once
      find(timeslots, (t) => {
        return t.auto_fill == 2 && t.source == "atus";
      });

    if (hasAtusData) {
      this.setState((state) => ({
        ...state,
        mariMessage: AppMessages.TrackATUSWarning,
        mariHighlight: true,
        mariActionLink: {
          onPress: () => this.onAtusDialogAction("cancel"),
          text: "Do not use American Time Use Survey Averages",
        },
        mariAction: [
          {
            onPress: () => this.onAtusDialogAction("continue"),
            text: "Continue with Averages",
            style: styles.bulkBtn,
            buttonTextStyle: styles.bulkBtnText,
            isDismiss: true,
          },
          {
            onPress: () => this.onAtusDialogAction(),
            text: "Connect Integrations",
            style: styles.bulkBtn,
            buttonTextStyle: styles.bulkBtnText,
          },
        ],
      }));
    } else {
      this.hideAtusWarning();
    }
  };

  hideAtusWarning = () => {
    this.updateStateKeys({
      mariMessage: "",
      mariHighlight: false,
      mariActionLink: null,
      tutorialStep: 0,
      showTutorials: false,
    });
  };

  // {'timeslotId': Set[elem1, elem2, elem 3]}
  _mapElementIdsToTimeslot = (timeslots, filterAtus = true) => {
    let idsHash = {};

    let filtered = filterAtus
      ? timeslots.filter((ts) => ts.auto_fill == 2 && !(ts.mood || ts.note))
      : timeslots.filter((ts) => ts.activity);

    filtered.forEach((ts) => {
      const elementIds = [];
      ["", 2, 3].forEach((index) => {
        const elem = ts[`activity${index}`];
        if (elem?.id) elementIds.push(elem.id);
      });

      if (elementIds) {
        idsHash[ts.id] = new Set(elementIds);
      }
    });

    return idsHash;
  };

  toggleBulkEditMode = (isBulkEdit) => {
    const { timeslots } = this.state;

    let autoFillHash = {};
    if (isBulkEdit) {
      // Preselect ATUS & predicted timeslots where the user has no journals
      autoFillHash = this._mapElementIdsToTimeslot(timeslots, true);
    }

    this.setState((state) => ({
      ...state,
      mariMessage: null,
      mariAction: null,
      mariActionLink: null,
      mariHighlight: false,
      isBulkEdit,
      bulkSelectedIds: autoFillHash,
    }));
  };

  toggleAllSelection = (selectAll) => {
    const { timeslots } = this.state;

    let bulkSelectedIds = {};
    if (selectAll) {
      bulkSelectedIds = this._mapElementIdsToTimeslot(timeslots, false);
    } else {
      bulkSelectedIds = {};
    }

    this.setState((state) => ({
      ...state,
      bulkSelectedIds: {
        ...bulkSelectedIds,
      },
    }));
  };

  toggleTimeslotSelection = ({ timeslodId, isSelected, elementIds = [] }) => {
    const { bulkSelectedIds } = this.state;

    if (isSelected) {
      if (!bulkSelectedIds[timeslodId]) {
        bulkSelectedIds[timeslodId] = new Set();
      }

      elementIds.forEach((elementId) =>
        bulkSelectedIds[timeslodId].add(elementId),
      );
    } else {
      elementIds.forEach((elementId) =>
        bulkSelectedIds[timeslodId]?.delete(elementId),
      );

      // Remove empty keys
      if (bulkSelectedIds[timeslodId]?.size == 0) {
        delete bulkSelectedIds[timeslodId];
      }
    }

    this.setState((state) => ({
      ...state,
      bulkSelectedIds: {
        ...bulkSelectedIds,
      },
    }));
  };

  showBulkRoutinesWarning = () => {
    const { isBulkEdit } = this.state;

    if (isBulkEdit) {
      this.updateMariMessage(
        { message: AppMessages.TrackRoutineEditModeInProgress, hasError: true },
        null,
      );

      setTimeout(() => {
        this.updateMariMessage({ message: "", hasError: false }, null);
      }, 2000);
    }
  };

  showBulkDateChangedWarnings = (onConfirm) => {
    const { selectedDate } = this.state;
    const dateHuman = moment(selectedDate).format("MMM DD");

    this.updateMariMessage(AppMessages.TrackBulkDateChangedWarning, [
      {
        onPress: () => {
          this.hideBulkDateChangedWarnings(false);
          onConfirm();
        },
        text: "Edit a different day",
        isDismiss: true,
        style: styles.bulkBtn,
        buttonTextStyle: styles.bulkBtnText,
      },
      {
        onPress: () => this.hideBulkDateChangedWarnings(false),
        text: `Continue editing ${dateHuman}`,
        style: styles.bulkBtn,
        buttonTextStyle: styles.bulkBtnText,
      },
    ]);
  };

  hideBulkDateChangedWarnings = (disableEditMode) => {
    this.setState((state) => ({
      ...state,
      mariMessage: null,
      mariAction: null,
      isBulkEdit: !disableEditMode,
      mariHighlight: false,
    }));
  };

  onClearSelectedTimeslots = () => {
    const { bulkSelectedIds } = this.state;

    const data = {};
    let hasChanges = false;
    Object.keys(bulkSelectedIds).forEach((key) => {
      hasChanges = true;
      let elementIdsSet = bulkSelectedIds[key];
      data[key] = Array.from(elementIdsSet);
    });

    if (!hasChanges) return;

    JournalHelper.clearBulkTimeslots(this.controller, data, () => {
      this.updateStateKeys({ isBulkEdit: false });

      // Refresh timeslots
      const selectedDate = this.state.selectedDate;
      this.controller.getApiData(
        "timeslots",
        { timeslotsDate: selectedDate },
        (timeslots) => {
          this.groupTimeslotsByDate(timeslots, selectedDate);
        },
      );
    });
  };

  // ------------------------------------- TIMER -------------------------------------
  startTimer = () => {
    SettingsHelper.toggleTimerCardPreferences(this.controller, true, () => {
      this.controller.changePage("rn:home_card");
    });
  };

  // ------------------------------------- RENDER -------------------------------------
  render() {
    const {
      isLoading,
      selectedDate,
      timeslots,
      computedTimeslotsUpdateCounter,
      TIMESLOTS_DATA,
      journalTimeslot,
      multipleElementsTimeslot,
      isAutoReview,
      currentTimePickerSlot,
      selectedMenuTimeslot,
      showTutorials,
      showBadgeCard,
      tutorialStep,
      showRoutinesDialog,
      integrationsTs,
      trackWarningTs,
      isAutoTrackMode,
      selectedIntegration,
      showEmptyPage,
      hasEnabledIntegrations,
      showTutorialOverlay,
      isBulkEdit,
      showIcons,
      bulkSelectedIds,
      hasManualTracking,
    } = this.state;

    const hasChunking = this.controller.isChunkPredictions();
    const { show_admin_tools } = this.controller.state?.settings || {};

    const selectedBulkCounts = bulkSelectedIds
      ? Object.keys(bulkSelectedIds).length
      : 0;

    const showEmptyState =
      showTutorialOverlay || (!hasManualTracking && !hasEnabledIntegrations);
    //(!hasManualTracking && (showEmptyPage || !hasEnabledIntegrations)); // 2022.04.21 Removed gating counter for new users (temp)

    // For tutorials highlight
    let firstUnconfirmedId = -1;
    if (tutorialStep == 4) {
      const sleepIndex = findLastIndex(timeslots, (t) =>
        isSleep(t?.activity?.name),
      );
      if (sleepIndex >= 0 && sleepIndex < timeslots.length) {
        firstUnconfirmedId = timeslots[sleepIndex + 1]?.id;
      }
    }

    const journalContext = {
      controller: this.controller,
      timeslots: timeslots,
      TIMESLOTS: TIMESLOTS_DATA,
      updateSelectedDate: this.updateSelectedDate,
      openJournalDialog: this.openJournalDialog,
      onTimeslotSelected: this.goToEditPage,
      confirmTimeslot: this.confirmTimeslot,
      toggleTimePicker: this.toggleTimePickerDialog,
      isAutoReview: isAutoReview,
      selectedDate,
      isLoading,
      isHomeCard: false,
      selectedTimeslots: timeslots,
      integrationsTs, // to highlight current selected ts
      openMenuOptions: this.toggleEditMenuOptions,
      expandTimeslot: this.expandTimeslot,
      onTutorialTimePickerOpen: this.onTutorialTimePickerOpen,
      tutorialStep,
      showTutorials,
      firstUnconfirmedId,
      goBackOneStep: this.goBackOneStep,
      onExitTutorial: this.onExitTutorial,
      showIntegrationsMenu: this.toggleIntegrationMenu,
      showRoutinesDialog: () => this.toggleRoutinesDialog(true),
      onRenderComplete: this.onRenderComplete,
      toggleAutoTrackMode: this.toggleAutoTrackMode,
      isAutoTrackMode,
      showEmptyState,
      // bulk edit
      isBulkEdit,
      bulkSelectedIds,
      toggleBulkEditMode: this.toggleBulkEditMode,
      toggleTimeslotSelection: this.toggleTimeslotSelection,
      toggleBulkSelection: this.toggleAllSelection,
    };

    return showEmptyState ? (
      <EmptyTrackPage
        ref={this.emptyPageRef}
        userCreatedTime={this.userCreatedTime}
        journalContext={journalContext}
        selectedDate={selectedDate}
        hasEnabledIntegrations={hasEnabledIntegrations}
        controller={this.controller}
        enableManualMode={this.enableManualMode}
        openOverlay={showTutorialOverlay}
        closeTutorialOverlay={this.closeTutorialOverlay}
      />
    ) : multipleElementsTimeslot ? (
      <MultipleElements
        timeslot={multipleElementsTimeslot}
        controller={this.controller}
        goBack={this.goBackFromElements}
      />
    ) : (
      <>
        <TrackBadgeCard isOpen={showBadgeCard} onPress={this.onBadgePress} />

        {selectedMenuTimeslot ? (
          <MenuEditOptionsPanel
            isPanelActive={!!selectedMenuTimeslot}
            close={() => this.toggleEditMenuOptions(null)}
            options={this.getMenuOptions(selectedMenuTimeslot)}
          />
        ) : null}

        {/* Journal dialog */}
        {journalTimeslot && journalTimeslot.id ? (
          <JournalDialog
            type={"timeslot"}
            item={journalTimeslot}
            controller={this.controller}
            close={() => this.openJournalDialog(null)}
            onJournalComplete={this.showManaMindFul}
          />
        ) : null}

        {/* Routines dialog */}
        {showRoutinesDialog ? (
          <RoutinesDialog
            controller={this.controller}
            selectedDate={selectedDate}
            timeslots={timeslots}
            applyRoutine={this.applyRoutine}
            close={() => this.toggleRoutinesDialog(null)}
          />
        ) : null}

        {/* Track warning dialog */}
        {trackWarningTs ? (
          <TrackWarningDialog
            controller={this.controller}
            data={trackWarningTs}
            goToToday={this.goToToday}
            confirm={this.continueWarningAction}
            close={() => this.toggleTrackWarningDialog(null)}
          />
        ) : null}

        {/* PAGE CONTENT */}
        <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
          <KeyboardAvoidingView
            style={appStyles.kbView}
            keyboardVerticalOffset={isAndroid ? 70 : 0}
            behavior="height"
          >
            <GestureRecognizer
              onSwipe={this.onSwipe}
              config={{
                velocityThreshold: 0.5,
                directionalOffsetThreshold: 50,
              }}
              style={styles.gestureWrapper}
            >
              <TrackHomeCalendar
                journalContext={journalContext}
                selectedDate={selectedDate}
              />
            </GestureRecognizer>

            {hasItems(timeslots) ? (
              <>
                <TrackHomeSelectAllSection
                  journalContext={journalContext}
                  timeslotsCount={timeslots.filter((t) => t.confirmed).length}
                />

                <TimeSlotsWrapper
                  key={"track_timeslots"}
                  controller={this.controller}
                  journalContext={journalContext}
                  navigation={this.props.navigation}
                  source={"track"}
                  styles={{ paddingBottom: 150 }}
                  timeslots={timeslots}
                  timeslotsUpdateCounter={computedTimeslotsUpdateCounter}
                  selectedDate={selectedDate}
                  isAutoReview={isAutoReview}
                  hasChunking={hasChunking}
                  showIcons={showIcons}
                  autoscroll
                  highlight
                />
              </>
            ) : null}

            {/* Bulk Clear Buttons: before FAB to show under for errors */}
            {isBulkEdit ? (
              <View style={[appStyles.footerButtons, styles.bulkButtons]}>
                <ManaButton
                  text={"Cancel"}
                  onPress={() => this.toggleBulkEditMode(false)}
                  styleText={styles.bulkBtnText}
                  style={[styles.bulkBtn, { width: "33%" }]}
                />
                <ManaButton
                  isDangerButton
                  disabled={selectedBulkCounts == 0}
                  text={`Clear Selected Timeslots ${
                    selectedBulkCounts ? "(" + selectedBulkCounts + ")" : ""
                  }`}
                  onPress={this.onClearSelectedTimeslots}
                  styleText={styles.bulkBtnText}
                  style={[
                    styles.bulkBtn,
                    {
                      marginLeft: 6,
                      flex: 1,
                    },
                  ]}
                />
              </View>
            ) : null}
            {/* End Bulk Clear Buttons */}

            {/* Mari */}
            <View style={[appStyles.footerOptions, { bottom: 0 }]}>
              {isAutoTrackMode ? (
                <AutoTrackFabButton
                  style={[
                    appStyles.fab,
                    { zIndex: 1000, bottom: isWeb ? 45 : 0 },
                  ]}
                  refresh={() => this.initTimeslots(true, null, true, true)}
                  viewManualMode={() => this.toggleAutoTrackMode(false)}
                  mariOptions={{
                    mariMessage: this.state.mariMessage || "",
                    mariAction: this.state.mariAction,
                  }}
                />
              ) : (
                <TrackFabButton
                  showManaMindful={this.state.showManaMindful}
                  jumpToUntracked={this.jumpToUntracked}
                  autotrackDay={this.autotrackDay}
                  syncCalendar={this.syncCalendar}
                  aboutThisScreen={this.aboutThisScreen}
                  startTimer={this.startTimer}
                  howToTrack={show_admin_tools ? this.howToTrack : null}
                  openRoutinesDialog={() => this.toggleRoutinesDialog(true)}
                  refresh={() => this.initTimeslots(true, null, true, true)}
                  viewAutoTrackMode={
                    show_admin_tools
                      ? () => this.toggleAutoTrackMode(true)
                      : null
                  }
                  style={[
                    appStyles.fab,
                    { zIndex: 1000, bottom: isWeb ? 0 : 0 },
                  ]}
                  mariOptions={{
                    hideMari: isBulkEdit,
                    mariActionLink: this.state.mariActionLink,
                    mariAction: this.state.mariAction,
                    mariMessage: this.state.mariMessage || {
                      message: "",
                    },
                    showTutorials,
                    highlight: this.state.mariHighlight,
                    hideActions: showTutorials || isBulkEdit,
                  }}
                />
              )}
            </View>
            {/* End Mari */}

            {/* Time picker */}
            <JournalTimePicker
              controller={this.controller}
              timeslot={currentTimePickerSlot}
              allTimeslots={this.controller.state.timeslots}
              minutesInterval={this.minutesInterval}
              onClose={this.closeTimePicker}
              toggleTimePicker={this.toggleTimePickerDialog}
              updateMariMessage={this.updateMariMessage}
              showTutorials={showTutorials}
              disableEndTime={showTutorials}
            />

            {integrationsTs ? (
              <TrackIntegrationsMenu
                controller={this.controller}
                isAutoTrackMode={isAutoTrackMode}
                timeslot={integrationsTs}
                close={() => this.toggleIntegrationMenu(null)}
                clearTimeslot={this.clearTimeslot}
                goToEditPage={this.goToDetailsPage}
                onLongPress={this.toggleIntegrationOptionsMenu}
              />
            ) : null}

            <IntegrationMenuOptions
              controller={this.controller}
              integration={selectedIntegration}
              close={() => this.toggleIntegrationOptionsMenu(null)}
              returnUrl={appPages.trackHome}
              timeslot={integrationsTs}
            />
          </KeyboardAvoidingView>
        </View>
        <AppStateWatcher
          onAppBecomesActive={() => {
            this.initTimeslots(true, null, true);
          }}
        />
      </>
    );
  }
}

const styles = StyleSheet.create({
  gestureWrapper: {
    zIndex: 1,
    backgroundColor: "#FFF",
    borderBottomLeftRadius: AppConfig.BORDER_RADIUS,
    borderBottomRightRadius: AppConfig.BORDER_RADIUS,
  },
  bulkButtons: {
    bottom: 0,
    paddingHorizontal: 16,
  },
  bulkBtn: {
    width: "50%",
    height: 32,
    borderRadius: 6,
  },
  bulkBtnText: {
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
